import { useState } from "react";
import { Chat } from "../Index";
import Terminal from "../TerminalBlock/Terminal";
import "./Intro.scss";

// import '../../../public/assets/assetsMeAvatar.png'

function Intro() {
  const [menuOpen, setmenuOpen] = useState(false);

  return (
    <div className="intro">
      <Chat menuOpen={menuOpen} setmenuOpen={setmenuOpen} />

      <div className="left">
        <div className="phone">
          <div className="innerPhone">
            <div className="content">
              <h1 className="title">Hello There, Stranger!</h1>
              <img src="assets/MeAvatar.png" alt="" className="avatar" />
              <h2 className="subtitle">Let's Build together</h2>
              <div className="btngrp">
                <button
                  onClick={() => setmenuOpen(!menuOpen)}
                  className="button"
                >
                  Let's Talk
                </button>
                <button
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/file/d/1gqcBhNg08iTqxqgijnx8zIiCQms7tAcG/view?usp=sharing",
                      "_blank"
                    )
                  }
                  className="button"
                >
                  Get Resume
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right">
        <div className="requirement-status">
          <h1 className="requirement-title">Recruitment Status</h1>
          <div className="requirement-status-row">
            <span className="requirement-status-light"></span>
            <h1 className="status">Looking for internships</h1>
          </div>
        </div>

        <div></div>
        <Terminal />
      </div>
    </div>
  );
}

export default Intro;
